import { EncryptedData } from '../encryption/domain';
import getDB from './util/getDB';

export const offlineEntitySubmitsIdbKeyVal = getDB<EncryptedData>('OfflineEntitySubmits', 1, 'data');
